/* eslint-disable react/prop-types */
import React, { createContext, useState, useContext } from 'react'
import { ReactReduxContext, useDispatch } from 'react-redux'

import LocalStorageService from '../services/LocalStorageService'
import UsuarioService from '../services/UsuarioService'
import Swal from 'sweetalert2'

const Context = createContext()

var service = new UsuarioService()

// eslint-disable-next-line react/prop-types
function AppProvider({ children, toast }) {
  const dispatch = useDispatch()
  const { store } = useContext(ReactReduxContext)
  const [authenticated, setAuthenticated] = useState(false)

  const [user, setUser] = useState('')
  const [_token, setToken] = useState('')
  const [term, setTerm] = useState(false)
  const [jwt, setJwt] = useState('')
  const [sidebarShow, setSidebarShow] = useState(true)

  // const [_role, setRole] = useState('')

  const theme = store.getState().theme

  React.useEffect(() => {
    const cmia_data = LocalStorageService.obterItem('_pmpv-cmia')
    const obj = cmia_data?.user
    setTerm(obj?.term)
  }, [])

  async function handleLogin(credentials) {
    service = new UsuarioService()
    const { email, password } = credentials

    if (email && password) {
      service
        .autenticar({
          identifier: email,
          password,
        })
        .then((response) => {
          // SETA AS VARIAVEIS
          const { user, jwt } = response.data

          if (user?.role?.name === 'SEMASF' || user?.role?.name === 'SEMASF_ADMIN') {
            dispatch({
              type: 'set',
              user: {
                id: user.id,
                email: user.email,
                username: user.username,
                role: user.role.name,
                term: user.termo,
              },
            })
            dispatch({ type: 'set', jwt: jwt })
            dispatch({ type: 'set', authenticated: true })
            dispatch({ type: 'set', sidebarShow: true })
            dispatch({ type: 'set', theme: theme })
            setUser(user)
            setJwt(jwt)
            setSidebarShow(true)
            setAuthenticated(true)
            LocalStorageService.addItem('_pmpv-cmia', {
              authenticated: true,
              sidebarShow: true,
              jwt,
              theme,
              user: {
                id: user.id,
                email: user.email,
                username: user.username,
                role: user.role.name,
                term: user.termo,
              },
            })
          } else {
            return response.status(403)
          }
        })
        .catch((erro) => {
          const { response } = erro

          if (response) {
            const { status } = response

            switch (status) {
              case 400:
                return Swal.fire(
                  `Erro de login`,
                  'Login ou senha inválida. Tente novamente.',
                  'error',
                )
              case 401:
                return Swal.fire(`Código do erro: ${401}`, 'Não autorizado', 'error')
              case 403:
                return Swal.fire(`Código do erro: ${403}`, 'Acesso restrito', 'error')
              default:
                return Swal.fire('Error', 'Erro desconhcido. Tente novamente mais tarde.', 'error')
            }
          } else {
            // eslint-disable-next-line react/prop-types
            toast.mensagemErro('Problemas no servidor ou Permissão negada')
          }
          return false
        })
      return true
    }
  }

  function handleLogOut() {
    setAuthenticated(false)
    setUser('')
    setToken('')
    setJwt('')
    LocalStorageService.removeItem('_pmpv-cmia')
    dispatch({
      type: 'set',
      user: '',
    })
    dispatch({ type: 'set', jwt: '' })
    dispatch({ type: 'set', authenticated: false })
  }

  return (
    <Context.Provider
      value={{
        sidebarShow,
        authenticated,
        handleLogin,
        handleLogOut,
        user,
        term,
        jwt,
        setUser,
        _token,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export { Context, AppProvider }
